<template>
  <!-- 修改密码 -->
  <div class="uni-login">
    <div class="login-content">
      <h1 style="text-align: center">设置新密码</h1>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <div style="margin-top: 30px;color: #999;">密码首字母大写、包含小写字母、数字、特殊字符、至少10位</div>
        <!-- 密码 -->
        <div class="uni-input-group">
          <span
            class="uni-label"
            :class="{
              active: isLabelActive == 'password' || ruleForm.password != '',
            }"
            @click="inputGroupClick"
            >新密码</span
          >

          <el-form-item prop="new_password" class="uni-input">
            <el-input
              v-model="ruleForm.new_password"
              name="password"
              :type="isOpen"
              @focus="changeLabelFocus"
              @blur="changeLabelBlur"
            ></el-input>
          </el-form-item>

          <i
            class="iconfont iconclose_eyes_"
            @click="showPassword"
            v-show="isOpen == 'password'"
          ></i>
          <i
            class="iconfont iconyanjing"
            @click="showPassword"
            v-show="isOpen == 'text'"
          ></i>
        </div>

        <!-- 密码 -->
        <div class="uni-input-group">
          <span
            class="uni-label"
            :class="{
              active:
                isLabelActive == 'rePassword' || ruleForm.rePassword != '',
            }"
            @click="inputGroupClick"
            >确认密码</span
          >

          <el-form-item prop="confirm_password" class="uni-input">
            <el-input
              v-model="ruleForm.confirm_password"
              name="rePassword"
              :type="isOpen"
              @focus="changeLabelFocus"
              @blur="changeLabelBlur"
            ></el-input>
          </el-form-item>

          <i
            class="iconfont iconclose_eyes_"
            @click="showPassword"
            v-show="isOpen == 'password'"
          ></i>
          <i
            class="iconfont iconyanjing"
            @click="showPassword"
            v-show="isOpen == 'text'"
          ></i>
        </div>

        <el-button type="primary" class="refer-btn" @click="refer('ruleForm')"
          >确定</el-button
        >
      </el-form>
    </div>
    <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { studentUpdatePwd } from "@/api/login";
export default {
  name: "ChangePwd",
  components: {},
  data() {
    return {
      currentClassId:"",
      dialogVisible: false, //test
      activeName: "first",
      isActive: false,
      isLabelActive: "",
      timerCount: 60,
      timer: null,
      isTimer: false,
      isOpen: "password",
      ruleForm: {
        mobile: this.$route.query.mobile,
        new_password: "",
        confirm_password: "",
      },
      rules: {
        new_password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        confirm_password: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("permission", {
      _ENTRANCETYPE: state => state._ENTRANCETYPE,  //成教/自考
      enterSchoolImgCheck: state => state.enterSchoolImgCheck,  //入学照审核状态
    }),
  },
  created() {
    this.currentClassId = this.$route.query.classId
  },
  methods: {
    // 退出
    async exit() {
        // loginOut(null).then(() => {
        // this.$store.dispatch('permission/setIsGenerateRoutes', '');
        await this.$store.dispatch('permission/logOut');
        // Cookies.remove('token');
        this.$message.success('退出成功');
        this.$router.replace("/Login");

        // });
    },

    // label动画
    inputGroupClick(event) {
      const target = event.currentTarget;
      target.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.focus();
    },
    changeLabelFocus(event) {
      const { name } = event.currentTarget;
      this.isLabelActive = name;
    },
    changeLabelBlur() {
      this.isLabelActive = "";
    },
    // 显示隐藏密码
    showPassword() {
      this.isOpen = this.isOpen === "password" ? "text" : "password";
    },
    // 提交
    refer(formName) {
      let data = this.ruleForm;
      if (data.password === data.rePassword) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            studentUpdatePwd({
              ...this.ruleForm,
              class_id:this.currentClassId
            }).then((res) => {
              if (res.code === 200) {
                if(this._ENTRANCETYPE === 'adult'){
                  if(this.enterSchoolImgCheck != 2){
                    this.$router.push({
                      path: "/uploadAdmissionPhotos",
                    });
                  } else {
                    this.$router.replace("/");
                  }
                }else{
                  this.$router.replace("/");
                }
              }
            });
          }
        });
      } else {
        this.$message.error("两次密码不一致");
      }
    },
  },
};
</script>

<style lang="scss">
// elementUi样式覆盖
.uni-login {
  .el-input__inner {
    border: none;
    border-bottom: 1px solid $gray;
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
<style lang="scss" scoped>
.uni-login {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url("~@/assets/images/login_bg.png") #eaeef7 center no-repeat;

  .exit-btn{
    position: fixed;
    top: 10px;
    right: 10px;
  }

  .login-content {
    width: 520px;
    background: $white;
    float: right;
    padding: 60px;
  }

  .refer-btn {
    width: 100%;
    height: 56px;
    border-radius: 28px;
    margin-top: 85px;
    font-size: 16px;
  }

  .uni-input-group {
    position: relative;
    margin-top: 40px;

    .uni-label {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: #999;
      transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      font-size: 16px;
      transform-origin: left top;
      z-index: $zindexTooltip;

      &.active {
        transform: translateY(-120%) scale(0.8);
      }
    }

    .iconfont {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 22px;
    }
  }
}
</style>
